// lib, util, constant
import { useState, useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import localStorageUtil from '@/common/utils/localStorageUtil';

// sevice
import { getListMCPServer, filterListMCPInProject } from './handler/MCPServerLogicHandler';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';

// component
import MCPServerListInProject from './components/MCPServerListInProject';
import LoadingPanel from '@/component/common/LoadingPanel';
import EditMCPServer from './components/EditMCPServer';
import MCPServerList from './components/MCPServerList';

// css
import './MCPServerSetting.css';

MCPServerSetting.propTypes = {
    panelType: PropTypes.string
};

function MCPServerSetting(props) {
    const { panelType } = props;

    const corporationDetail = useRecoilValue(corporationAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const userDetail = useRecoilValue(userAtom);

    const [isLoading, setIsLoading] = useState(false);
    const [listSettingApi, setListSettingApi] = useState([]);
    const [listSettingApiProject, setListSettingApiProject] = useState([]);
    let oauth2Data = Utils.convertJSONDataToObject(localStorageUtil.getOauth2LastAuthen()) || {};

    const [editApiData, setEditApiData] = useState(oauth2Data);

    const fetchList = () => {
        setIsLoading(true);
        getListMCPServer(
            panelType,
            corporationDetail.id,
            projectInuseDetail.id,
            userDetail.id,
            Constant.MCP_SERVER_GET_METHOD.GET_LIST_PAGINATION
        )
            .then(res => {
                const listApi = res?.listMCPServer || [];
                if (!Utils.isEmptyArray(listApi)) {
                    setListSettingApi(listApi);
                    let listSettingOfProject = filterListMCPInProject(listApi);
                    listSettingOfProject = listSettingOfProject.map(i => ({
                        ...i,
                        authMethod: Utils.transformAuthMethod(i?.authMethod),
                    }));
                    setListSettingApiProject(listSettingOfProject);
                }
            })
            .catch(error => {
                console.log('getListMCPServer error >>>', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchList();
        return () => {
            setListSettingApi([]);
            setListSettingApiProject([]);
            setIsLoading(false);
        };
    }, []);

    const handleBackWithReload = () => {
        setEditApiData({});
        setListSettingApi([]);
        fetchList();
    };

    const renderContent = () => {
        if (Utils.isEmptyObject(editApiData)) {
            if (panelType === Constant.PANEL_TYPE.PROJECT_MANAGEMENT) {
                return (
                    <MCPServerListInProject
                        setIsLoading={setIsLoading}
                        panelType={panelType}
                        setEditApiData={setEditApiData}
                        corporationDetail={corporationDetail}
                        projectInuseDetail={projectInuseDetail}
                        userDetail={userDetail}
                        listSettingApiProject={listSettingApiProject}
                        setListSettingApiProject={setListSettingApiProject}
                        props={props}
                    />
                );
            }
            return (
                <MCPServerList
                    setIsLoading={setIsLoading}
                    panelType={panelType}
                    listSettingApi={listSettingApi}
                    setListSettingApi={setListSettingApi}
                    setEditApiData={setEditApiData}
                    corporationDetail={corporationDetail}
                    projectInuseDetail={projectInuseDetail}
                    userDetail={userDetail}
                    props={props}
                />
            );
        }

        return (
            <EditMCPServer
                setIsLoading={setIsLoading}
                editApiData={editApiData}
                setEditApiData={setEditApiData}
                setListSettingApi={setListSettingApi}
                listSettingApi={listSettingApi}
                corporationDetail={corporationDetail}
                projectInuseDetail={projectInuseDetail}
                userDetail={userDetail}
                panelType={panelType}
                props={props}
                handleBackWithReload={handleBackWithReload}
            />
        );
    };

    return (
        <div className="mcp-server-wrapper">
            <LoadingPanel isLoading={isLoading} />
            {renderContent()}
        </div>
    );
}

export default MCPServerSetting;
